import { BlurView } from 'expo-blur';
import * as React from 'react';
import { StyleSheet, View, type ViewProps } from 'react-native';

import { GLASS, type GlassDepth } from '@sixam/config/glass';
import { cn } from '@sixam/ui/utils';

type GlassPanelProps = ViewProps & {
  children: React.ReactNode;
  contentClassName?: string;
  depth?: GlassDepth;
  intensity?: number;
};

function GlassPanel({
  children,
  className,
  contentClassName,
  depth = 'surface',
  intensity = GLASS.blur[depth],
  ...props
}: GlassPanelProps) {
  return (
    <View className={cn('relative overflow-hidden rounded-2xl bg-black/35', className)} {...props}>
      <BlurView intensity={intensity} tint="dark" style={StyleSheet.absoluteFill} />
      <View
        style={[
          StyleSheet.absoluteFill,
          {
            backgroundColor: GLASS.overlay.surface,
            pointerEvents: 'none',
          },
        ]}
      />
      <View
        style={[
          StyleSheet.absoluteFill,
          {
            borderColor: GLASS.edge.shadow,
            borderRadius: 16,
            borderWidth: 1,
            pointerEvents: 'none',
          },
        ]}
      />
      <View
        style={{
          backgroundColor: GLASS.edge.highlight,
          height: StyleSheet.hairlineWidth,
          left: 16,
          opacity: 0.75,
          pointerEvents: 'none',
          position: 'absolute',
          right: 16,
          top: 0,
        }}
      />
      <View className={cn('relative', contentClassName)}>{children}</View>
    </View>
  );
}

export { GlassPanel };
